import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createBlock(_component_van_empty, {
    image: require('../../assets/empty@2x.png'),
    description: `${_ctx.$route.query.tip || '当前连接已失效'}`
  }, null, 8, ["image", "description"]))
}